import backOfACard from "./back-of-a-card.svg";
import deactivatedPhysicalCard from "./deactivated-physical-card.svg";
import deactivatedVirtualCard from "./deactivated-virtual-card.svg";
import physicalCard from "./physical-card.svg";
import virtualCard from "./virtual-card.svg";

export default {
  deactivatedPhysicalCard,
  deactivatedVirtualCard,
  physicalCard,
  virtualCard,
  backOfACard,
};
